import axios from 'axios'

export const medicareApiClient = {
  async getBeneficiaryByMbi (mbi: string) {
    try {
      const response = await axios.post(`${process.env.REACT_APP_CORE_API_URL}/beneficiaries`, { mbi })

      return response.data
    } catch (error) {
      console.error(error)
      let errorMessage = 'Error getting data from Core API'

      if (error?.response?.status) {
        errorMessage = `HTTP status (${error.response.status}) - ${errorMessage}`
      }

      throw new Error(errorMessage)
    }
  },

  async getBeneficiaryByReqToken (reqToken: string) {
    try {
      const response = await axios.get(`${process.env.REACT_APP_CORE_API_URL}/beneficiary/${reqToken}`)

      return response.data
    } catch (error) {
      console.error(error)
      let errorMessage = 'Error getting data from Core API'

      if (error?.response?.status) {
        errorMessage = `HTTP status (${error.response.status}) - ${errorMessage}`
      }

      throw new Error(errorMessage)
    }
  }
}
